import React, { useEffect } from 'react'
import Cards3 from '../Cards3'
import GTranslate from '../GTanslate';
import Carousel3 from '../Carousel3';
import { FaIndustry, FaWarehouse, FaGlobe, FaCogs } from 'react-icons/fa';

const Enterprise = () => {
    useEffect(() => {
        window.scrollTo(0, 0); 
    }, []);
    
    return (
        <main className="min-h-screen bg-gradient-to-b from-gray-50 via-white to-gray-50 font-montserrat">
            {/* Fixed Language Selector */}
            <div className="fixed top-6 right-6 z-50">
                    <GTranslate />
                 
            </div>

            {/* Hero Section */}
            <section className="relative pt-24 pb-20 overflow-hidden bg-gradient-to-br from-gray-50 to-white">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center gap-3 mb-6">
                            <div className="w-16 h-1 bg-gradient-to-r from-red-600 to-red-700 rounded-full" />
                            <span className="text-sm font-semibold text-red-700 uppercase tracking-wider">Üretim Ağımız</span>
                            <div className="w-16 h-1 bg-gradient-to-r from-red-600 to-red-700 rounded-full" />
                        </div>
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            Global <span className="text-red-700">Üretim Gücümüz</span>
                        </h1>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            6 kıtada yayılan üretim tesislerimiz ve ileri teknoloji üretim kapasitemiz
                        </p>
                    </div>

                    {/* Stats */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
                        {[
                            { value: '8', label: 'Üretim Tesisi', icon: FaIndustry, color: 'text-red-600' },
                            { value: '40+', label: 'Üretim Hattı', icon: FaCogs, color: 'text-red-600' },
                            { value: '500+', label: 'Teknik Personel', icon: FaWarehouse, color: 'text-red-600' },
                            { value: '6', label: 'Kıtada Üretim', icon: FaGlobe, color: 'text-red-600' }
                        ].map((stat, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 text-center hover:shadow-xl transition-shadow duration-300">
                                <stat.icon className={`w-8 h-8 ${stat.color} mx-auto mb-3`} />
                                <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
                                <div className="text-sm text-gray-600">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Carousel Section */}
            <section className="py-16 bg-white border-y border-gray-200">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            Üretim <span className="text-red-700">Tesislerimiz</span>
                        </h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Teknoloji ve kalitenin buluştuğu modern üretim tesislerimiz
                        </p>
                    </div>
                    <Carousel3 />
                </div>
            </section>

            {/* Production Cards Section */}
            <section className="py-20 bg-gradient-to-b from-white to-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-gray-900 mb-6">
                            Üretim <span className="text-red-700">Uzmanlıklarımız</span>
                        </h2>
                        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                            Her biri alanında uzmanlaşmış üretim birimlerimiz ve ileri teknoloji çözümlerimiz
                        </p>
                    </div>
                    <Cards3 />
                </div>
            </section>

            {/* Manufacturing Excellence Section */}
            {/* <section className="py-20 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
<div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23dc2626\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]" />                </div>
                
                <div className="relative z-10 max-w-7xl mx-auto px-6">
                    <div className="grid lg:grid-cols-2 gap-16 items-center">
                        <div>
                            <div className="inline-flex items-center gap-3 mb-6">
                                <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-700 rounded-xl flex items-center justify-center">
                                    <FaIndustry className="w-6 h-6 text-white" />
                                </div>
                                <span className="text-sm font-semibold text-red-400 uppercase tracking-wider">Üretim Felsefemiz</span>
                            </div>
                            <h3 className="text-4xl font-bold text-white mb-6">
                                Kalite ve <span className="text-red-300">Teknolojinin</span> Birleşimi
                            </h3>
                            <p className="text-lg text-gray-300 leading-relaxed mb-8">
                                Her üretim sürecimizde, en son teknolojileri ISO standartlarıyla birleştirerek 
                                <span className="font-semibold text-white"> 6 kıtada</span> aynı yüksek kaliteyi sunuyoruz.
                            </p>
                            <div className="grid grid-cols-2 gap-6">
                                {[
                                    { label: 'ISO 9001 Kalite', value: 'Sertifikalı' },
                                    { label: 'OEE Oranı', value: '95%+' },
                                    { label: 'Ar-Ge Yatırımı', value: '8%' },
                                    { label: 'Üretim Otomasyon', value: '85%' }
                                ].map((item, idx) => (
                                    <div key={idx} className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/20">
                                        <div className="text-2xl font-bold text-white mb-2">{item.value}</div>
                                        <div className="text-sm text-red-300">{item.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 border border-gray-700 shadow-2xl">
                            <div className="flex items-center gap-3 mb-8">
                                <FaGlobe className="w-8 h-8 text-red-400" />
                                <h4 className="text-2xl font-bold text-white">Global Üretim Ağı</h4>
                            </div>
                            <div className="space-y-4">
                                {[
                                    { region: 'Türkiye', plants: 3, capacity: 'Ana Üretim Üssü' },
                                    { region: 'Almanya', plants: 1, capacity: 'Avrupa Merkezi' },
                                    { region: 'İngiltere', plants: 1, capacity: 'İnovasyon Merkezi' },
                                    { region: 'ABD', plants: 1, capacity: 'Amerika Üssü' }
                                ].map((item, idx) => (
                                    <div key={idx} className="flex items-center justify-between p-5 bg-gray-800/50 rounded-xl hover:bg-gray-800 transition-colors">
                                        <div>
                                            <div className="font-semibold text-white">{item.region}</div>
                                            <div className="text-sm text-gray-400">{item.plants} üretim tesisi</div>
                                        </div>
                                        <div className="px-3 py-1 bg-red-900/30 text-red-300 rounded-full text-sm font-medium">
                                            {item.capacity}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-8 pt-6 border-t border-gray-700">
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-white mb-2">6</div>
                                    <div className="text-sm text-gray-400">Kıtada Üretim Deneyimi</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </main>
    )
}

export default Enterprise